import React from 'react';

import { Grid } from '@lp/ds-next';

import SAOfferDetailsContent from './SAOfferDetailsContent';
import PageTitle from '@/components/layout/PageTitle';

const SAOfferDetails = () => (
  <Grid container justifyContent="center" spacing={3}>
    <Grid item mobile={11}>
      <PageTitle title="OFFER" />
    </Grid>
    <Grid item mobile={11}>
      <SAOfferDetailsContent />
    </Grid>
  </Grid>
);

export default SAOfferDetails;
